<template>
  <div>
    <slot name="list-heading"></slot>
    
    <slot 
      name="list-controls" 
      :filter-options="filterOptions"
      :filters="filters"
      :set-page="setPage"
      :items="getCorrectList"
    ></slot>
    <pager 
      v-if="getCorrectList.length > 0"
      :items-length="itemTotal" 
      :items-per-page="itemsPerPage"
      :active-index="activeIndex"
      @page-to="pageToIndex"
      className="pager_borderBottom"
      >
    </pager>
    <template v-if="getCorrectList.length > 0">
      <!-- list iterator placeholder (for simple lists uses ListDisplay) -->
      <slot name="list-display" :items="getCorrectList" :list-display-wrapper-class="blockColumnsClass">
      </slot>
    </template>

    <template v-else>
      <slot name="list-no-results">
        <div class="m-positionRelative"><!-- Adding default loading markup in slot until it gets overwritten -->
          <div class="loadingContainer">
            <div class="loading"></div>
          </div>
        </div>
      </slot>
    </template>
    <pager 
      v-if="getCorrectList.length > 0"
      :items-length="itemTotal" 
      :items-per-page="itemsPerPage"
      :active-index="activeIndex"
      @page-to="pageToIndex"
      className="pager_borderBottom"
      >
    </pager>
  </div>
</template>

<script>
import Pager from './Pager.vue'
import ListDisplay from './ListDisplay.vue';

export default {
  components: {
    Pager,
  },
  props: {
    pageToIndex: {
      type: Function
    },
    items: {
      type: Array
    },
    filterOptions: {
      type: Object
    },
    blockColumns: {
      type: Number
    },
    blockColumnsOverride: {
      type: String
    },
    itemsPerPage: {
      type: Number
    },
    itemTotal: {
      type: Number
    },
    activeIndex: {
      type: Number
    }

  },
  data() {
    return {
      filters: {}
    };
  },
  created() {
    //dynamically create filters in data object
    for (const item in this.filterOptions) {
      // needs to use $set method to hook up reactivity
      this.$set(this.filters, item, "");
    }
  },
  computed: {
    pagedList() {
      return this.items.slice(0, this.itemsPerPage);
    },
    getCorrectList() {
      // return paged list if attribute is specified, else return stimple filtered list
      if (this.itemsPerPage) { 
        return this.pagedList;
      }
      return this.items;
    },
    blockColumnsClass() {
      // MD block columns will be half of LG rounded up.
      if(this.blockColumnsOverride) {
          return this.blockColumnsOverride;
      }
      if (this.blockColumns === 2) {
        return `flexBlocks flexBlocks_2upMD flexBlocks_2upLG` 
      }
      return `flexBlocks flexBlocks_${Math.ceil(this.blockColumns / 2)}upMD flexBlocks_${this.blockColumns}upLG`
    }
  },
  methods: {
    selectFilter(category, value) {
      this.filters[category] = value;
    },
    setPage(page) {
      this.activeIndex = page;
    },
    resetSearch() {

    }
  }
};
</script>

<style lang="scss">
</style>

